// extracted by mini-css-extract-plugin
export default {"page-container":"XIAMRouters_page-container__ByXmS"};